module.exports = __webpack_public_path__ + "static/media/29COICT6.0629aca2.jpg";